// extracted by mini-css-extract-plugin
export default {"wrapper":"Mondo_wrapper__K5nOM","contentCard":"Mondo_contentCard__yZaM2"};